import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from 'antd';
import DrawerModal from '../shared/DrawerModal';
import styles from './ConfirmBlockModal.styles';
import {
  closeModal,
  getIsVisibleModal,
} from '../../redux/store/ui/common/index';
import { selectCarActiveBookings } from '../../redux/store/userData/cars';
import { useIntl } from 'react-intl';
import LinkToBooking from '../shared/LinkToBooking';
import ListItem from '../shared/ListItem';

const ConfirmBlockModal = ({ onUpdate }) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const activeBookings = useSelector(selectCarActiveBookings);
  const visibleModal = useSelector(getIsVisibleModal('ConfirmBlockModal'));

  const handleOnSubmit = (e: { preventDefault: () => void }) => {
    e.preventDefault();
    onUpdate(e, true);
    dispatch(closeModal('ConfirmBlockModal'));
  };

  const handleOnCancel = (e: { preventDefault: () => void }) => {
    e.preventDefault();
    dispatch(closeModal('ConfirmBlockModal'));
  };

  useEffect(() => {
    if (activeBookings?.length < 1) {
      dispatch(closeModal('ConfirmBlockModal'));
    }
  }, [activeBookings]);

  return (
    <>
      <DrawerModal
        visible={visibleModal}
        onClose={() => {
          dispatch(closeModal('ConfirmBlockModal'));
        }}
      >
        <div className="confirm-block-modal">
          <div>
            <p data-testid="ConfirmBlockModal-modalLabel" className="label">
              {intl.formatMessage({
                id: `fleet.admin.booking.car.active.bookings`,
              })}
            </p>
            <div style={{ margin: '16px 0 24px 0' }}>
              {activeBookings?.map((booking) => (
                <ListItem
                  key={booking?.id}
                  style={{ marginLeft: 0, marginBottom: 16 }}
                  value={
                    <LinkToBooking
                      key={booking?.id}
                      booking={booking}
                      text={booking?.bookingPresentableId}
                    />
                  }
                />
              ))}
            </div>
          </div>
          <Button className="cancel-button" onClick={handleOnCancel}>
            {intl.formatMessage({
              id: `cancel`,
            })}
          </Button>
          <Button
            className="submit-button-confirm-block"
            onClick={handleOnSubmit}
          >
            {intl.formatMessage({
              id: `fleet.admin.confirm.block.car`,
            })}
          </Button>
        </div>
      </DrawerModal>
      <style jsx>{styles}</style>
    </>
  );
};

export default ConfirmBlockModal;
